import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { fetchCourseById } from "../../../../../reduxToolkit/Course/coursesSpecSlice";

// core components
import navBarStyles from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Link } from "react-router-dom";

import { Breadcrumb } from "antd";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import { fetchAssessmentResponsibilities } from "../../../../../reduxToolkit/features/AssessmentResponsibilities/AssessmentResponsibilitiesSlice";


import ErrorModal from "../../../../Components/ErrorModal";

import { useTranslation } from "react-i18next";
import DropDownButtonAssessmentResponsibilities from '../../../../Components/DropDownButtonAssessmentResponsibilities';

const useNavBarStyles = makeStyles(navBarStyles);

const useStyles = makeStyles(styles);

export default function AssessmentResponsibilitiesList({ match }) {
  const { t } = useTranslation();
  const navBarClasses = useNavBarStyles();

  const classes = useStyles();


  const { id } = match.params;
  const dispatch = useDispatch();

  const [openErrorModal, setOpenErrorModal] = React.useState(false);
  const [handledError, setHandledError] = React.useState("");
  const [disabledStatus, setDisabledStatus] = useState(false);

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };


  const fetchAssessmentResponsibilitiesByCourseId = async () => {
    try {
      const resultAction = await dispatch(
        fetchAssessmentResponsibilities(id)
      ).unwrap();
      dispatch(fetchCourseById(id));
      console.log("success");
    } catch (err) {
      setHandledError(err);
      handleOpenErrorModal();
      console.log("err from DatesAndTimesAllocations fetch by course id", err);
    }
  };

  useEffect(() => {
    fetchAssessmentResponsibilitiesByCourseId();
    if (localStorage.getItem("CourseState") != "Draft") {
      setDisabledStatus(true);
    }
  }, [dispatch]);

  const course = useSelector((state) => state.CourseSpec.courseSpecification);
  const AssessmentResponsibilities = useSelector(
    (state) => state.AssessmentResponsibility.AssessmentResponsibilities
  );
  const AssessmentResponsibilitiesStatus = useSelector(
    (state) => state.AssessmentResponsibility.AssessmentResponsibilitiesStatus
  );

  console.log("course to be updated", course);

  console.log("course", course);
  console.log("AssessmentResponsibilities", AssessmentResponsibilities);

  let content;

  if (AssessmentResponsibilitiesStatus === "loading") {
    content = <div className="loader">{t("Loading...")}</div>;
  } else if (AssessmentResponsibilitiesStatus === "succeeded") {
    content = (
      <div>
        <GridItem>
          <Breadcrumb separator=">">
            

            <Breadcrumb.Item>
              <Link to={`/citrine/CourseSpecificationList/`}>
                {t("Courses List")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={`/citrine/courseSpecDetails/${course && course.id && course.id
                  }`}
              >
                {course && course.title && course.title}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={`/citrine/specification/course/${course && course.id && course.id}/AssessmentResponsibilities`}
                style={{ color: "orange" }}
              >
                {t("Assessment Responsibilities List")}
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </GridItem>
        <GridContainer>
          <GridItem>
            {disabledStatus ? (
              <p></p>
            ) : (
              <Link
                to={`/citrine/specification/course/${course && course.id && course.id}/AssessmentResponsibilities/create`}
              >
                <Button color="info" className={classes.updateProfileButton}>
                  {t("Add")}
                </Button>
              </Link>
            )}
          </GridItem>
        </GridContainer>
        <GridContainer>
          {AssessmentResponsibilities &&
            AssessmentResponsibilities.map((Element) => (
              <GridItem key={Element.id} xs={12} sm={12} md={4}>
                <Card style={{ height: 200, textAlign: "start" }}>
                  <CardBody>
                    <GridContainer xs={12} sm={12} md={12}>
                      <GridItem xs={10} sm={10} md={10}>

                        <h4
                          className={classes.cardProductTitle}
                          style={{ textAlign: "start" }}
                        >
                          <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            {t("Teaching staff")} :
                            {Element && Element.teaching_staff_ids && Element.teaching_staff_ids.map((el) => el)}
                          </a>
                        </h4>

                        <h4
                          className={classes.cardProductTitle}
                          style={{ textAlign: "start", color: "orange" }}
                        >
                          <a
                            href="#pablo"
                            onClick={(e) => e.preventDefault()}
                            style={{ color: "orange" }}
                          >
                            {t("Field supervisor")} : {Element.field_supervisor}
                          </a>
                        </h4>


                        <h4
                          className={classes.cardProductTitle}
                          style={{ textAlign: "start" }}
                        >
                          <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            {t("Others")} :
                            {Element.others}
                          </a>
                        </h4>





                      </GridItem>
                      <GridItem xs={2} sm={2} md={2} style={{ zIndex: 1 }}>
                        {disabledStatus ? (
                          <p></p>
                        ) : (
                          <DropDownButtonAssessmentResponsibilities
                            AssessmentResponsibility_ID={Element.id}
                            courseID={course && course.id}
                          />
                        )}
                      </GridItem>
                    </GridContainer>
                  </CardBody>
                </Card>
              </GridItem>
            ))}
        </GridContainer>
      </div>
    );
  }
  return (
    <div>
      {content}
      <ErrorModal
        open={openErrorModal}
        handleClose={handleCloseErrorModal}
        handledError={handledError}
      />
    </div>
  );
}
